import axios from "axios";
import { notifyUnauthorized } from "../auth/sessionEvents";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
});

// Attach Authorization header when a token exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pvapp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = String(error?.config?.url || "");
    const detail = error?.response?.data?.detail;
    const isAuthLogin = url.includes("/auth/login");

    if (status === 401 && !isAuthLogin) {
      notifyUnauthorized(detail);
    }

    return Promise.reject(error);
  }
);

export default api;
